import { render } from "./ImageContainer.vue?vue&type=template&id=28116f77&scoped=true"
import script from "./ImageContainer.vue?vue&type=script&lang=js"
export * from "./ImageContainer.vue?vue&type=script&lang=js"

import "./ImageContainer.vue?vue&type=style&index=0&id=28116f77&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28116f77"]])

export default __exports__